// extracted by mini-css-extract-plugin
export default {"content":"Home_content__H2PXq","header":"Home_header__3IJ7C","back":"Home_back__2E-fg"};